import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';

import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js"
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import ParadigmaAsyncSeeker from "../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js";
import api from "../../../../api";
import functions from "../../../../functions";

import './styles.scss'

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      Nombre: "",
      PorcentajeRecargo: 0,
      PorcentajeDescuento: 0,
      PorcentajeRecargoWEB: 0,
      PorcentajeDescuentoWEB: 0,
      PorcentajeRecargoSIGE: 0,
      PorcentajeDescuentoSIGE: 0,
      ListasAplica: [],
      postVariables: ["Nombre", "PorcentajeRecargoWEB", "PorcentajeDescuentoWEB", "ListasAplica"],
      errors: [],
    };
  }

  static propTypes = {
    onSubmit: PropTypes.func,
    id: PropTypes.func,
    action: PropTypes.oneOf(['EDIT', 'DETAIL']).isRequired,
  }

  resetForm() {
    this.setState({
      id: null,
      Nombre: "",
      PorcentajeRecargo: 0,
      PorcentajeDescuento: 0,
      PorcentajeRecargoWEB: 0,
      PorcentajeDescuentoWEB: 0,
      PorcentajeRecargoSIGE: 0,
      PorcentajeDescuentoSIGE: 0,
      ListasAplica: [],
      errors: [],
    });
  }

  getData() {
    const { postVariables } = this.state;
    let data = {};
    postVariables.forEach(x => {
      data[x] = this.state[x];
    });
    return data;
  }
  ;
  setData(data) {
    if (data.success) {
      this.setState({
        id: data.id,
        Nombre: data.Nombre,
        PorcentajeRecargo: data.PorcentajeRecargo,
        PorcentajeDescuento: data.PorcentajeDescuento,
        PorcentajeRecargoWEB: data.PorcentajeRecargoWEB,
        PorcentajeDescuentoWEB: data.PorcentajeDescuentoWEB,
        PorcentajeRecargoSIGE: data.PorcentajeRecargoSIGE,
        PorcentajeDescuentoSIGE: data.PorcentajeDescuentoSIGE,
        ListasAplica: data.ListasAplica,
      })
    }
  }

  setErrors(errors) {
    this.setState({
      errors: errors,
    });
  }

  onChangeField(field, value) {
    this.setState(prevState => {
      let errors = prevState.errors;
      if (errors) errors[field] = null;
      prevState.errors = errors;
      prevState[field] = value;
      return prevState;
    });
  }

  getError(field) {
    let errors = this.state.errors;
    if (errors) return errors[field];
    else return null;
  }

  modalVars() {
    const { action } = this.props;
    if (action == "EDIT") {
      return {
        get: true,
        submitType: "PUT",
        title: "Editar Condición de Pago",
        buttonTitle: "Editar",
        danger: false,
        buttonIcon: "fa fa-pencil fa-lg",
        successMessage: "La Condición de Pago ha sido editado con éxito.",
        saveButton: true,
        saveButtonLabel: "Guardar",
        buttonClass: "",
        disabled: false,
        id: this.props.id,
      };
    } else if (action == "DETAIL") {
      return {
        get: true,
        submitType: null,
        title: "Condición de Pago",
        buttonTitle: "Ver",
        danger: false,
        buttonIcon: "fa fa-search fa-lg",
        successMessage: "",
        saveButton: false,
        buttonClass: "",
        disabled: true,
        id: this.props.id,
      };
    }
  }

  render() {
    let vars = this.modalVars();
    const { action } = this.props;
    return (
      <ParadigmaModal
        getUrl={(vars.get ? api.gestion.ventas.condicionesdepago : null)}
        submitUrl={(vars.submitType ? api.gestion.ventas.condicionesdepago : null)}
        submitType={vars.submitType}
        id={vars.id}

        onGotData={(data) => this.setData(data)}
        onGotErrors={(errors) => this.setErrors(errors)}
        onSubmit={(e) => this.props.onSubmit(e) & this.resetForm()}
        onClose={() => this.resetForm()}
        onPreSubmit={() => this.getData()}

        title={vars.title}
        className="modal-condicion-pago"

        danger={vars.danger}
        buttonClass={vars.buttonClass}

        successMessage={vars.successMessage}
        missingIdMessage={"Debe seleccionar una fila."}
        saveButtonLabel={vars.saveButtonLabel}
        buttonTitle={vars.buttonTitle}
        buttonIcon={vars.buttonIcon}
        saveButton={vars.saveButton}
        saveReloadButton={action == "CREATE"}
        saveReloadButtonLabel="Guardar y Nuevo"
        closeButton={true}
      >
        <ParadigmaLabeledInput
          disabled={vars.disabled}
          md={[2, 10]}
          label={"Nombre"}
          value={this.state.Nombre}
          onChange={(e) => this.onChangeField('Nombre', e.target.value)}
          error={() => this.getError('Nombre')}
        />
        <Row>
          <Col>
            <ParadigmaLabeledInput
              disabled={true}
              type="number"
              classNames={["my-auto text-nowrap", "my-auto text-right"]}
              md={[4, 8]}
              label="% Rec. SIGE"
              value={this.state.PorcentajeRecargoSIGE}
              onChange={(e) => this.onChangeField('PorcentajeRecargoSIGE', e.target.value)}
              error={() => this.getError('PorcentajeRecargoSIGE')}
            />
          </Col>
          <Col>
            <ParadigmaLabeledInput
              disabled={true}
              type="number"
              label="% Desc. SIGE"
              classNames={["my-auto text-nowrap", "my-auto text-right"]}
              md={[4, 8]}
              value={this.state.PorcentajeDescuentoSIGE}
              onChange={(e) => this.onChangeField('PorcentajeDescuentoSIGE', e.target.value)}
              error={() => this.getError('PorcentajeDescuentoSIGE')}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <ParadigmaLabeledInput
              disabled={vars.disabled}
              type="number"
              classNames={["my-auto text-nowrap", "my-auto text-right"]}
              md={[4, 8]}
              label="% Rec. WEB"
              value={this.state.PorcentajeRecargoWEB}
              onChange={(e) => this.onChangeField('PorcentajeRecargoWEB', e.target.value)}
              error={() => this.getError('PorcentajeRecargoWEB')}
            />
          </Col>
          <Col>
            <ParadigmaLabeledInput
              disabled={vars.disabled}
              type="number"
              label="% Desc. WEB"
              classNames={["my-auto text-nowrap", "my-auto text-right"]}
              md={[4, 8]}
              value={this.state.PorcentajeDescuentoWEB}
              onChange={(e) => this.onChangeField('PorcentajeDescuentoWEB', e.target.value)}
              error={() => this.getError('PorcentajeDescuentoWEB')}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <ParadigmaLabeledInput
              disabled={true}
              type="number"
              classNames={["my-auto text-nowrap", "my-auto text-right"]}
              md={[4, 8]}
              label="% Rec Final."
              value={functions.calcularIncrementoPorcentual(this.state.PorcentajeRecargoSIGE, this.state.PorcentajeRecargoWEB)}
              onChange={(e) => { }}
              error={() => { }}
            />
          </Col>
          <Col>
            <ParadigmaLabeledInput
              disabled={true}
              type="number"
              label="% Desc. Final"
              classNames={["my-auto text-nowrap", "my-auto text-right"]}
              md={[4, 8]}
              value={functions.calcularDecrementoPorcentual(this.state.PorcentajeDescuentoWEB, this.state.PorcentajeDescuentoSIGE)}
              onChange={(e) => { }}
              error={() => { }}
            />
          </Col>
        </Row>
        <Row className="border-top mt-2">
          <Col>
            <ParadigmaLabeledInput
              md={[6, 6]}
              label={"Listas de Precios en que que aplica"}
              inputComponent={
                <ParadigmaAsyncSeeker
                  disabled={vars.disabled}
                  url={api.gestion.precios.listas}
                  value={this.state.ListasAplica}
                  multiselect={true}
                  valueField="Codigo"
                  displayField="Nombre"
                  parameters={{ paginationEnabled: "False", filters: ["DeBaja=False", "Codigo[not]=000000"], sort: ["Nombre"], fields: ['Codigo', 'Nombre'] }}
                  onChange={(data) => this.onChangeField("ListasAplica", data ? data.map(item => item.Codigo) : [])}
                />
              }
              error={() => this.getError('ListasAplica')}
            />
            <small>Dejar el campo vacio implica que aplica para todas las listas de precios.</small>
          </Col>
        </Row>

      </ParadigmaModal>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/CondicionesDePago/Modal.js